import axios from "axios";

const laravelPublicAxiosClient = axios.create();
laravelPublicAxiosClient.defaults.baseURL = `${import.meta.env.VITE_LARAVEL_API_URL}/api` as string;

laravelPublicAxiosClient.interceptors.request.use((config) => {
  config.headers.set("Accept", "application/json");
  config.headers.set("Content-Type", "application/json");
  return config;
});

export default laravelPublicAxiosClient;
